import { CommonModule } from '@angular/common';
import { Component, Input, SimpleChanges } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { DetalleFactura } from '../../../interfaces/documento-factura.interface';
import { HelpersService } from '../../../services/helpers.service';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormatearFechaPipe } from '../../../pipes/formatear-fecha.pipe';
import { FormatearNumeroPipe } from '../../../pipes/formatear-numero.pipe';
import { FormatearRutPipe } from '../../../pipes/formatear-rut.pipe';


@Component({
  selector: 'cabecera-detalle-factura',
  standalone: true,
  imports: [FlexLayoutModule, CommonModule, FontAwesomeModule, FormatearFechaPipe, FormatearNumeroPipe, FormatearRutPipe],
  templateUrl: './cabecera-detalle-factura.component.html',
  styleUrl: './cabecera-detalle-factura.component.scss'
})
export class CabeceraDetalleFacturaComponent {

  iconIva = faChevronDown;
  iconImpuesto = faChevronDown;
  
  @Input() detalleFact!:DetalleFactura;
  ocultarInfo:boolean = false;
  showDataIva:boolean = false;
  showDataImpuesto:boolean = false;
  monedaLocal: string = "";

  
  ngOnInit(): void {
    this.detalleFact = <DetalleFactura>{};
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.monedaLocal = this.helpersServices.getCurrencyFromTimezone(userTimezone);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.detalleFact = changes['detalleFact'].currentValue;
  }

  acordeon(){
    this.ocultarInfo = !this.ocultarInfo;
  }

  constructor( private helpersServices: HelpersService) {
  }

  formatearFecha(fecha : string){
    return this.helpersServices.formatearFecha(fecha);
  }

  showDetailIva(){
    this.showDataIva = !this.showDataIva;
    this.iconIva = (!this.showDataIva)?faChevronDown:faChevronUp;
  }

  showDetailImpuestos(){
    this.showDataImpuesto = !this.showDataImpuesto;
    this.iconImpuesto = (!this.showDataImpuesto)?faChevronDown:faChevronUp;
  }

  

}
